export default "__VITE_ASSET__Ch5_eRaN__"